import React, { useState } from "react";
import InputField from "../../ResuableCompoment/InputField";
import SelectField from "../../ResuableCompoment/SelectField";
import Button from "../../ResuableCompoment/Button";
import Statemaster from "../../../DummyJson/Statemaster.json";
import useApi from "../../CustomHooks/useApi";
import { checkUID } from "../../ResuableCompoment/ValidateAadhar";
import Popup from "../../ResuableCompoment/Popup";

const CreateRole = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    fatherName: "",
    mobileNumber: "",
    address: "",
    email: "",
    dob: "",
    gender: "",
    panCard: "",
    aadhaarCard: "",
    state: "",
    district: "",
    role: "",
    shId: "",
    rmId: "",
    pincode: "",
  });

  const [errors, setErrors] = useState({});
  const [roleOptions, setRoleOptions] = useState([]);

  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [navigateOnOk, setNavigateOnOk] = useState(false);

  const { callApi } = useApi("/staff/onboard/create/role", "POST");
  const { callApi: roleapicall } = useApi("/staff/onboard/get/roles", "GET");

  const validateField = (name, value) => {
    let errorMsg = "";

    if (name === "fullName" || name === "fatherName") {
      if (!/^[A-Za-z\s]{1,100}$/.test(value)) {
        errorMsg = "Only alphabets & spaces allowed.";
      }
    }

    if (name === "mobileNumber") {
      if (!/^[6-9]\d{9}$/.test(value)) {
        errorMsg = "Invalid mobile number.";
      }
    }

    if (name === "email") {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        errorMsg = "Invalid email format.";
      }
    }

    if (name === "dob") {
      const age =
        new Date().getFullYear() - new Date(value).getFullYear();
      if (age < 18) errorMsg = "Minimum age should be 18.";
    }

    if (name === "panCard") {
      if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value)) {
        errorMsg = "Invalid PAN format.";
      }
    }

    if (name === "aadhaarCard") {
      if (!/^\d{12}$/.test(value) || !checkUID(value)) {
        errorMsg = "Invalid Aadhaar number.";
      }
    }

    return errorMsg;
  };

  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    setErrors((prev) => ({ ...prev, [name]: "" }));
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "role" && (value === "STATE_HEAD" || value === "ASM")) {
      const roleType =
        value === "STATE_HEAD" ? "REGIONAL_MANAGER" : "STATE_HEAD";

      const response = await roleapicall(null, { role_type: roleType });

      if (response) {
        setRoleOptions(
          response.map((item) => ({
            value: item.userId,
            label: `${item.meta.fullName} (${item.mobile_number})`,
            Rmlabel: item?.userHierarchyResponse?.parent?.name || "",
          }))
        );
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};
    Object.keys(formData).forEach((field) => {
      const error = validateField(field, formData[field]);
      if (error) newErrors[field] = error;
    });

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    const payload = {
      aadhaar_card: formData.aadhaarCard,
      address: formData.address,
      district: formData.district,
      date_of_birth: formData.dob,
      email: formData.email,
      father_name: formData.fatherName,
      full_name: formData.fullName,
      gender: formData.gender,
      mobile_number: formData.mobileNumber,
      pan_card: formData.panCard,
      pincode: formData.pincode,
      role: formData.role,
      state: formData.state,
    };

    const parentId =
      formData.role === "ASM"
        ? formData.shId
        : formData.role === "STATE_HEAD"
        ? formData.rmId
        : null;

    const response = parentId
      ? await callApi(payload, { parent_id: parentId })
      : await callApi(payload);

    if (response) {
      setPopupMessage("Role created successfully!");
      setNavigateOnOk(true);
      setShowPopup(true);

      setFormData({
        fullName: "",
        fatherName: "",
        mobileNumber: "",
        address: "",
        email: "",
        dob: "",
        gender: "",
        panCard: "",
        aadhaarCard: "",
        state: "",
        district: "",
        role: "",
        shId: "",
        rmId: "",
        pincode: "",
      });
    } else {
      setPopupMessage("Failed to create role. Please try again.");
      setNavigateOnOk(false);
      setShowPopup(true);
    }
  };

  return (
    <div className="h-full bg-[#EEF1F5] p-4">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-[#0A2A4F]">
          CREATE ROLE (RM / SH / ASM)
        </h2>
      </div>

      <div className="bg-white rounded-xl border shadow-sm">
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-5 p-6"
        >
          {[
            { label: "PAN Card", name: "panCard" },
            { label: "Aadhaar Card", name: "aadhaarCard" },
            { label: "Mobile Number", name: "mobileNumber" },
            { label: "Full Name", name: "fullName" },
            { label: "Father's Name", name: "fatherName" },
            { label: "Address", name: "address" },
            { label: "Email", name: "email" },
            { label: "Date of Birth", name: "dob", type: "date" },
            { label: "Pin Code", name: "pincode" },
          ].map((f) => (
            <div key={f.name}>
              <InputField
                label={f.label}
                name={f.name}
                type={f.type || "text"}
                value={formData[f.name]}
                onChange={handleInputChange}
              />
              {errors[f.name] && (
                <p className="text-red-600 text-sm">{errors[f.name]}</p>
              )}
            </div>
          ))}

          <SelectField
            label="Gender"
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
            options={[
              { value: "Male", label: "Male" },
              { value: "Female", label: "Female" },
              { value: "Other", label: "Other" },
            ]}
          />

          <SelectField
            label="State"
            name="state"
            value={formData.state}
            onChange={handleInputChange}
            options={Statemaster.states.map((s) => ({
              value: s.state,
              label: s.state,
            }))}
          />

          <SelectField
            label="District"
            name="district"
            value={formData.district}
            onChange={handleInputChange}
            options={
              Statemaster.states.find(
                (s) => s.state === formData.state
              )?.districts.map((d) => ({ value: d, label: d })) || []
            }
          />

          <SelectField
            label="Role"
            name="role"
            value={formData.role}
            onChange={handleInputChange}
            options={[
              { value: "REGIONAL_MANAGER", label: "RM" },
              { value: "STATE_HEAD", label: "SH" },
              { value: "ASM", label: "ASM" },
            ]}
          />

          {formData.role === "STATE_HEAD" && (
            <SelectField
              label="Select RM"
              name="rmId"
              value={formData.rmId}
              onChange={handleInputChange}
              options={roleOptions}
            />
          )}

          {formData.role === "ASM" && (
            <>
              <SelectField
                label="Select SH"
                name="shId"
                value={formData.shId}
                onChange={handleInputChange}
                options={roleOptions}
              />

              <SelectField
                label="RM (Auto)"
                value={
                  roleOptions.find((o) => o.value === formData.shId)
                    ?.Rmlabel || ""
                }
                options={[
                  {
                    value:
                      roleOptions.find((o) => o.value === formData.shId)
                        ?.Rmlabel,
                    label:
                      roleOptions.find((o) => o.value === formData.shId)
                        ?.Rmlabel,
                  },
                ]}
                disabled
              />
            </>
          )}

          <div className="md:col-span-2 pt-4">
            <Button type="submit" fullWidth label="Create Role" />
          </div>
        </form>
      </div>

      {showPopup && (
        <Popup
          message={popupMessage}
          onClose={() => setShowPopup(false)}
          navigateTo={navigateOnOk ? "/totalcount" : null}
        />
      )}
    </div>
  );
};

export default CreateRole;

